var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkbox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check_box_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check_box_24dp_5F6368_FILL0_wght400_GRAD0_opsz24-(Background/Mask)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0833333,18.75 C13.7777778,18.4444444 13.3888889,18.2916667 12.9166667,18.2916667 C12.4444445,18.2916667 12.0555556,18.4444444 11.75,18.75 C11.4444444,19.0555556 11.2916667,19.4444445 11.2916667,19.9166667 C11.2916667,20.3888889 11.4444444,20.7777778 11.75,21.0833333 L16.5,25.8333333 C16.8333333,26.1666667 17.2222222,26.3333333 17.6666667,26.3333333 C18.1111111,26.3333333 18.5,26.1666667 18.8333333,25.8333333 L28.25,16.4166667 C28.5555556,16.1111111 28.7083333,15.7222222 28.7083333,15.25 C28.7083333,14.7777778 28.5555556,14.3888889 28.25,14.0833333 C27.9444444,13.7777778 27.5555555,13.625 27.0833333,13.625 C26.6111111,13.625 26.2222222,13.7777778 25.9166667,14.0833333 L17.6666667,22.3333333 L14.0833333,18.75 Z M5.97916667,34.0208333 C5.32638888,33.3680555 5,32.5833333 5,31.6666667 L5,8.33333333 C5,7.41666667 5.32638888,6.63194446 5.97916667,5.97916667 C6.63194446,5.32638888 7.41666667,5 8.33333333,5 L31.6666667,5 C32.5833333,5 33.3680555,5.32638888 34.0208333,5.97916667 C34.6736111,6.63194446 35,7.41666667 35,8.33333333 L35,31.6666667 C35,32.5833333 34.6736111,33.3680555 34.0208333,34.0208333 C33.3680555,34.6736111 32.5833333,35 31.6666667,35 L8.33333333,35 C7.41666667,35 6.63194446,34.6736111 5.97916667,34.0208333 Z M31.6666667,31.6666667 L31.6666667,8.33333333 L8.33333333,8.33333333 L8.33333333,31.6666667 L31.6666667,31.6666667 Z",
    id: "Vector",
    fill: "#9CABBD",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.43f8f49558ef26bc8d56b952e014e7ca.svg";
export { ForwardRef as ReactComponent };